import { render, staticRenderFns } from "./PlatformDetail.vue?vue&type=template&id=4d445a04&scoped=true"
import script from "./PlatformDetail.vue?vue&type=script&lang=js"
export * from "./PlatformDetail.vue?vue&type=script&lang=js"
import style0 from "./PlatformDetail.vue?vue&type=style&index=0&id=4d445a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d445a04",
  null
  
)

export default component.exports